import React, { useEffect } from "react";
import "./styles.css";
import { useLocation } from "react-router-dom"; // Import useLocation to get the current path
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import { useAuth } from "./providers/AuthContext";

import LoginPage from "./pages/LoginPage";
import { SidebarProvider } from "./providers/SidebarContext";
import OverviewPage from "./pages/OverviewPage";
import AgreementsPage from "./pages/agreement/AgreementsPage";
import EditAgreementPage from "./pages/agreement/EditAgreementPage";
import UsersPage from "./pages/user/UsersPage";
import EditUserRoute from "./pages/user/EditUserRoute";
import LicensesPage from "./pages/license/LicensesPage";
import EditLicensesPage from "./pages/license/EditLicensesPage";
import HistoryBillingPage from "./pages/historybilling/HistoryBillingPage"; // Import the HistoryBillingPage component
import NotFoundPage from "./pages/NotFountPage";
import NotAuthorizedPage from "./pages/NotAuthorizedPage"; // Import the NotAuthorizedPage component
import AccessDeniedPage from "./pages/AccessDeniedPage";
import LoadingPage from "./pages/LoadingPage";
import AddOnServicesPage from "./pages/addOnServices/AddOnServicesPage";
import EditAddOnServicesPage from "./pages/addOnServices/EditAddOnServicesPage";
import IndexAdjustmentsPage from "./pages/indexAdjustments/IndexAdjustmentsPage";
import EditIndexAdjustmentsPage from "./pages/indexAdjustments/EditIndexAdjustmentsPage";
import EditHistoryBillingPage from "./pages/historybilling/EditHistoryBillingPage";
import CreateUserRoute from "./pages/user/CreateUserRoute";
import DomainsPage from "./pages/domains/DomainsPage";
import DeviceInventoryPage from "./pages/deviceInventory/DeviceInventoryPage";
import DeviceInventoryDetailPage from "./pages/deviceInventory/DeviceInventoryDetailPage";
import HardwareOrderPage from "./pages/hardware/HardwareOrderPage";
import OffboardUserPage from "./pages/offboarding/OffboardUserPage";

function App() {
  const { isAuthenticated, login, loading, isRole, isRolesSet } = useAuth();
  useEffect(() => {
    console.log("Is Authenticated: ", isAuthenticated);
  }, [isAuthenticated]);

  useEffect(() => {
    console.log("Is Roles set: ", isRolesSet);
  }, [isRole, isRolesSet]);

  if (loading) {
    return <LoadingPage></LoadingPage>;
  }

  return (
    <SidebarProvider>
      <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <OverviewPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/agreements"
          element={
            <ProtectedRoute>
              <AgreementsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/agreements/:agreementPublicId/edit"
          element={
            <ProtectedRoute>
              <EditAgreementPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId"
          element={
            <ProtectedRoute>
              <EditAgreementPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/:tenantPublicId"
          element={
            <ProtectedRoute>
              <EditAgreementPage />
            </ProtectedRoute>
          }
        />

        {/*         <Route
          path="/:agreementPublicId/tenants"
          element={
            <ProtectedRoute>
              <TenantsPage />
            </ProtectedRoute>
          }
        /> */}

        <Route
          path="/:agreementPublicId/:tenantPublicId/users"
          element={
            <ProtectedRoute>
              <UsersPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/:tenantPublicId/users/:userPublicId"
          element={
            <ProtectedRoute>
              <EditUserRoute />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/:tenantPublicId/users/create-user"
          element={
            <ProtectedRoute>
              <CreateUserRoute />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/:tenantPublicId/users/offboard-user/:userPublicId?"
          element={
            <ProtectedRoute>
              <OffboardUserPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/:tenantPublicId/hardware-order"
          element={
            <ProtectedRoute>
              <HardwareOrderPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/:tenantPublicId/licenses"
          element={
            <ProtectedRoute>
              <LicensesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/:tenantPublicId/licenses/:licensePublicId"
          element={
            <ProtectedRoute>
              <EditLicensesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/domains"
          element={
            <ProtectedRoute>
              <DomainsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/device-inventory"
          element={
            <ProtectedRoute>
              <DeviceInventoryPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/device-inventory/:managedDevicePublicId"
          element={
            <ProtectedRoute>
              <DeviceInventoryDetailPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/add-on-services"
          element={
            <ProtectedRoute>
              <AddOnServicesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/add-on-services/:addOnServicePublicId"
          element={
            <ProtectedRoute>
              <EditAddOnServicesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/indexadjustments"
          element={
            <ProtectedRoute>
              <IndexAdjustmentsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/indexadjustments/:indexAdjustmentPublicId"
          element={
            <ProtectedRoute>
              <EditIndexAdjustmentsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/history-billing"
          element={
            <ProtectedRoute>
              <HistoryBillingPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/history-billing/:billingHistoryPublicId"
          element={
            <ProtectedRoute>
              <EditHistoryBillingPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="*"
          element={
            <ProtectedRoute>
              <NotFoundPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/unauthorized"
          element={<NotAuthorizedPage />} // Add the NotAuthorizedPage route
        />

        <Route path="/login" element={<LoginPage />} />
      </Routes>
    </SidebarProvider>
  );
}

export default App;

const ProtectedRoute = ({ children }) => {
  const {
    isAuthenticated,
    login,
    isRole,
    isRolesSet,
    initializeAndFetchRoles,
  } = useAuth();
  const { inProgress } = useMsal(); // Ensure no interaction is in progress
  const location = useLocation();

  useEffect(() => {
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      console.log("Starting login process...");
      // Check if the user is not authenticated and no interaction is in progress
      sessionStorage.setItem("redirectPath", location.pathname); // Store the current path before redirecting
      login(); // Trigger login if the user is not authenticated
    }
  }, [isAuthenticated, login, inProgress, location]);

  if (inProgress === "startup" || inProgress === "login") {
    return <LoadingPage />;
  }

  if (isAuthenticated && !isRolesSet) {
    initializeAndFetchRoles();
  }

  if (isRolesSet && (isRole("poweruser") || isRole("basic"))) {
    return children;
  } else if (isRolesSet) {
    return <AccessDeniedPage />;
  } else {
    return <LoadingPage />;
  }
};
